import React, {useEffect, useState} from 'react'
import {getByIdResource, updateResource} from "../../service/http-service";
import {Combo} from "../../ui/Combo";
import './ProfileFormsStyle.css'
import FormHeader from '../../../assets/img/profile-images/form-header.png'

export const ProfileSkillForm = ({entityTemp,setEntityTemp,title,updateEntity,setUpdateEntity, setAddEntity}) => {

    const [entity, setEntity] = useState()

    const [skills, setSkills] = useState([])

    const [showError, setShowError] = useState(false)
    const [showSecondField, setShowSecondField] = useState(false)
    const [showSecondFieldError, setShowSecondFieldError] = useState(false)

    useEffect (() => {
        setEntity(entityTemp)
        if(entityTemp.candidate) {
            getByIdResource('skills/get_by_candidate', entityTemp.candidate.id).then((data) => {
                console.log(`education types`)
                console.log(data.data)
                setSkills(data.data)
            })
        }
    }, []);


    return (

            <div className="background-form col-12 p-0">
                {(entity) && (<>
                        <img src={FormHeader} className="form-header-image"/>
                        <div className="profile_add_button form-button-title">{title}</div>
                        <div className="col-lg-10 offset-lg-1">
                            {(skills && skills.length > 0) &&
                                (
                                    <Combo
                                        placeholder="Вештини"
                                        tooltipText="Одберете вештина"
                                        comboClass="combo-form"
                                        onChange={(e) => {
                                            setShowSecondField(false)
                                            setShowError(false)
                                            let chosenSkill = {};
                                            chosenSkill.id = e.target.value;
                                            setEntity({ ...entity, skill: chosenSkill })
                                            let el = skills.find(el => el.id.toString() === chosenSkill.id.toString());
                                            setShowSecondField(el.other)
                                        }}
                                        onClear={() => setEntity({...entity, skill: null})}
                                        array={skills}/>)}

                            {showError && <b>Ве молиме одберете вештина</b>}

                            {showSecondField &&  <input className="input-form w-100" type="text" required={true}
                                                        placeholder="Внесете стручна вештина"
                                                        value={entity.otherSkill}
                                                        onChange={(e) => {
                                                            setEntity({...entity, otherSkill: e.target.value})
                                                            setShowSecondFieldError(false)
                                                        }}
                            />}
                            {showSecondFieldError && <b>Ве молиме внесете стручна вештина</b>}
                        </div>

                        <div className="col-lg-10 offset-lg-1 d-flex justify-content-between">
                            <div
                                className="btn-form"
                                onClick={()=>
                                {setAddEntity(false)
                                    setEntityTemp({candidate: entity.candidate})
                                }}
                            >Затвори</div>
                            <div
                                className="btn-form"
                                onClick={(e) => {
                                    if((showSecondField === true) && (entity.skill && entity.skill.id !== "0")
                                        && (!entity.otherSkill || entity.otherSkill === "")){
                                        setShowSecondFieldError(true)
                                        setShowError(false)
                                    }else if((showSecondField === true) && (entity.skill && entity.skill.id !== "0")
                                        && (entity.otherSkill && entity.otherSkill !== "")) {
                                        updateResource('candidate_skills', entity)
                                            .then((data) => {
                                                console.log(data.data)
                                                setAddEntity(false)
                                                setEntityTemp({candidate: entity.candidate})
                                                setUpdateEntity(!updateEntity)
                                                setShowError(false)})
                                        setShowSecondFieldError(false)
                                    } else if ((showSecondField === false) && (entity.skill && entity.skill.id !== "0")){
                                        updateResource('candidate_skills', entity)
                                            .then((data) => {
                                                console.log(data.data)
                                                setAddEntity(false)
                                                setEntityTemp({candidate: entity.candidate})
                                                setUpdateEntity(!updateEntity)
                                                setShowError(false)})
                                    } else {
                                        setShowError(true)
                                    }
                                }}
                            >Зачувај</div>
                        </div>
            </>
            )
                }
        </div>
    )
}